import cx from "classnames";
import { useState } from "react";

import { TabBar } from "src/components/tabbar";
import { TabSection } from "src/pages/dealRoom/pages/assets";
import DealInsights from "./dealInsights";
import DealDetails from "./dealDetails";
import ContentShared from "./contentShared";

import styles from "./styles.module.scss";

const DealSlider = ({ onClose }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className={styles.container}>
      <div onClick={onClose} className={styles.iconContainer}><i className={cx("paperflite-close", styles.close)} /></div>
      <div className={styles.topContainer}>
        <h3 className={styles.heading}>more details</h3>
        <p className={styles.subtext}>Track your deal progress and key details in one view.</p>
      </div>

      <TabBar
        className={cx(styles.tabs)}
        gap={32}
        tabSize="equal"
        active={activeTab}
        onSelectionChange={(tab) => setActiveTab(tab)}
      >
        <div className={cx(styles.tab, { [styles.active]: activeTab == 0 })}>
          Deal Insights
        </div>
        <div className={cx(styles.tab, { [styles.active]: activeTab == 1 })}>
          Deal Details
        </div>
        <div className={cx(styles.tab, { [styles.active]: activeTab == 2 })}>
          Content Shared
        </div>
      </TabBar>
      <div className={cx(styles.stacks, styles.tabContainer)}>
        <div className={styles.tabBody}>
          <TabSection index={0} selected={activeTab}>
            <DealInsights />
          </TabSection>
          <TabSection index={1} selected={activeTab}>
            <DealDetails />
          </TabSection>
          <TabSection index={2} selected={activeTab}>
            <ContentShared />
          </TabSection>
        </div>
      </div>
    </div>
  )
}

export default DealSlider;